import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';

export interface ISupportRequestPayload {
    message: string;
    preferredContactMethod: string;
    contactValue: string;
    postHogDistinctId: string | null;
    name?: string;
    currentPage: string;
}

export interface ISupportContactInfo {
    email: string;
    phoneNumber: string | null;
    displayName: string;
}

const apiUrls = {
    contactInfo: '/SupportRequests/ContactInfo',
    submit: '/SupportRequests',
};

export class SupportRequestApi extends BaseApi {
    static getContactInfo(): Promise<ISupportContactInfo> {
        return this.sendApiRequest<ISupportContactInfo>({
            method: HttpMethodEnum.GET,
            path: `${this.apiUrl}${apiUrls.contactInfo}`,
        });
    }

    static submit(data: ISupportRequestPayload): Promise<void> {
        return this.sendApiRequest({
            method: HttpMethodEnum.POST,
            path: `${this.apiUrl}${apiUrls.submit}`,
            data: data as any,
        });
    }
}
